import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("path", {
  d: "M3 3h18v2H3V3z"
}), 'MaximizeTwoTone');